import marquee from 'vanilla-marquee';

class TextTicker {
	constructor(dom) {
		this.NAME = 'TextTicker';
		this.dom = dom;
	}

	init() {
		const track = this.dom.querySelector('[data-text-ticker-track]');
		if (!track) return;

		const direction = this.dom.dataset.direction || 'left';
		const speed = parseInt(this.dom.dataset.speed, 10) || 50;

		new marquee(track, {
			duplicated: true,
			startVisible: true,
			direction,
			speed,
		});
	}
}

export default TextTicker;
